import { useMutation } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";
import SAVE_INFUSION_DROGAS_VISITA_CD, { adaptInfusionDrogasCDInput } from '../../../../../../data/graphQL/mutations/Visitas/saveInfusionDrogasVisitaCD';

export const InfusionDrogasCD = ({ readOnly, onSaveRef, onExposeFormatted }) => {
  const [formData, setFormData] = useState({});
  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_INFUSION_DROGAS_VISITA_CD);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      //Estos campos son requeridos si infusionDrogas es true
      if (['drogaAInfundir', 'dosis', 'frecuenciaDrogas', 'cumpleCriteriosIngreso', 'infusionesPrevias'].includes(newInput.name))
      newInput.required = !!formData?.infusionDrogas;

      if (['cantidadInfusionesPrevias', 'lugarInfusionesPrevias', 'presentoReaccionesAdversas'].includes(newInput.name)) {
        newInput.required = !!formData?.infusionesPrevias;
        newInput.hidden = !formData?.infusionesPrevias;
      }

      if (!formData.infusionDrogas && newInput.name !== 'infusionDrogas') newInput.hidden = true;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });

  }, [readOnly, formData]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (name === 'infusionDrogas' && !value) {
      handleChange('drogaAInfundir', null);
      handleChange('dosis', null);
      handleChange('frecuenciaDrogas', null);
      handleChange('cumpleCriteriosIngreso', null);
      handleChange('infusionesPrevias', false);
      handleChange('cantidadInfusionesPrevias', null);
      handleChange('lugarInfusionesPrevias', null);
      handleChange('presentoReaccionesAdversas', null);
    }

    if (name === 'infusionesPrevias' && !value) {
      handleChange('cantidadInfusionesPrevias', null);
      handleChange('lugarInfusionesPrevias', null);
      handleChange('presentoReaccionesAdversas', null);
    }
  };

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { input: adaptInfusionDrogasCDInput(formData) } });

    setVisita((prev) => ({
      ...prev,
      ...formData
    }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'infusionDrogasCD',
      stepName: 'Infusion de Drogas',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
            <Grid container spacing={2}>
                {formattedInputs.
        filter((input) => !input.hidden).
        map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
                            <RenderInputByTypeMobile
            key={input.name}
            input={input}
            value={formData[input.name]}
            handleChange={handleChange} />
          
                        </Grid>
        )}
            </Grid>
        </CardBox>);

};

const inputs = [
{
  name: "infusionDrogas",
  displayName: "Infusión de drogas",
  type: "boolean",
  required: true,
  lightTitle: true
},
{
  name: "drogaAInfundir",
  displayName: "Droga a infundir?",
  type: "long_string",
  required: false
},
{
  name: "dosis",
  displayName: "Dosis",
  type: "long_string",
  required: false
},
{
  name: "frecuenciaDrogas",
  displayName: "Frecuencia",
  type: "long_string",
  required: false
},
{
  name: "cumpleCriteriosIngreso",
  displayName: "Cumple criterios de ingreso?",
  type: "long_string",
  required: false
},
{
  name: "infusionesPrevias",
  displayName: "Realizó infusiones previas",
  type: "boolean",
  lightTitle: true,
  required: false
},
{
  name: "cantidadInfusionesPrevias",
  displayName: "Cuantas",
  type: "long_string",
  required: false
},
{
  name: "lugarInfusionesPrevias",
  displayName: "Donde",
  type: "long_string",
  required: false
},
{
  name: "presentoReaccionesAdversas",
  displayName: "Presento reacciones adversas",
  type: "long_string",
  required: false
}];